import { YearmonthsState } from "./types";
import { Module } from "vuex";
import { RootState } from "@/store/types";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getDefaultMonth } from "@/types";

export const state: YearmonthsState = {
  yearmonths: [getDefaultMonth().substr(0, 7)],
  error: false
};

const namespaced = true;

export const yearmonths: Module<YearmonthsState, RootState> = {
  namespaced,
  state,
  actions,
  mutations
};
